<div class="table-container">
  @if (data && data.length > 0) {
  <table class="table">
    <thead>
      <tr>
        <ng-container *ngFor="let column of visibleColumns; let i = index">
          <th (click)="onSort(column.key)" [class.sortable]="column.sortable">
            {{ column.label }}
            <span
              *ngIf="column.sortable && sortColumn === column.key"
              class="sort-icon"
            >
              {{
                sortDirection === "asc"
                  ? "↑"
                  : sortDirection === "desc"
                  ? "↓"
                  : ""
              }}
            </span>
          </th>
        </ng-container>
        <th>
          <button class="responsive" (click)="toggleColumnMenu()">
            <img src="./assets/flecha.svg" alt="desplegar" />
          </button>
          <div *ngIf="showColumnMenu" class="column-menu">
            <ul>
              <li
                *ngFor="let column of hiddenColumns"
                (click)="switchColumn(column)"
              >
                {{ column.label }}
              </li>
            </ul>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of paginatedData; trackBy: trackByFn">
        <tr>
          <ng-container *ngFor="let column of visibleColumns">
            <td>
              @if(column.key === 'actions') { @if(item.claimNumber) {
              <div class="actions-container">
                @if(!item.orders?.length) {
                <button class="no-btn" (click)="onSelectClick(item)">
                  <i class="bi bi-file-text"></i>
                </button>
                } @else {
                <div class="select-container">
                  <select
                    [(ngModel)]="item.selectedOrderId"
                    class="order-select"
                  >
                    <option value="all">Todas</option>
                    @for(order of item.orders; track order.orderId) {
                    <option [value]="order.orderId">
                      {{ order.tipoOrden }}
                    </option>
                    }
                  </select>
                  <button
                    class="btn-s-new download-btn"
                    (click)="
                      actionClick.emit({
                        item: item,
                        orderId: item.selectedOrderId
                      })
                    "
                  >
                    <i class="bi bi-download"></i>
                  </button>
                </div>
                }
              </div>
              } @else { No disponible } } @else if(column.key === 'invoice' &&
              item.transactionType === 'RC-C') {
              <button
                [hidden]="item.transactionType !== 'RC-C'"
                class="btn-s-new"
                (click)="actionClick.emit(item)"
              >
                <i class="bi bi-download"></i>
              </button>
              } @else if (column.key === 'quote') {
              <button class="btn-s-new" (click)="actionClick.emit(item)">
                <i class="bi bi-download"></i>
              </button>
              } @else if (column.key === 'downloadDocuments') {
              <div class="select-container">
                <select class="document-select" [(ngModel)]="item.process">
                  <option value="" hidden>Selecciona un proceso</option>
                  @for(process of item.processTypes; track process.process) {
                  <option [value]="process.process">
                    {{ process.processName }}
                  </option>
                  }
                </select>
                <button
                  class="btn-s-new"
                  (click)="
                    actionClick.emit({ item: item, process: item.process })
                  "
                >
                  <i class="bi bi-download"></i>
                </button>
              </div>
              } @else if (column.key === 'download') {
              <button class="btn-s-new" (click)="actionClick.emit(item)">
                <i class="bi bi-download"></i>
              </button>
              } @else {
              {{ formatValue(item[column.key], column) }}
              }
            </td>
          </ng-container>
        </tr>
      </ng-container>
      @if(isAging) {
      <tr id="totals-row">
        <td>Totales</td>
        @for(column of visibleColumns.slice(1); track column) {
        <td>{{ formatValue(calculatedTotals[column.key], column) }}</td>
        }
      </tr>
      }
    </tbody>
  </table>
  } @else {
  <div class="no-data-message">
    {{ mensajeMostrar }}
  </div>
  }
</div>
@if (config.showPagination !== false) {

<div class="footer-container">
  <nav aria-label="Navegación de páginas">
    <ul class="pagination">
      <li class="page-item">
        <a
          class="page-link"
          [class.disabled]="currentPage === 1"
          (click)="onPageChange(currentPage - 1)"
        >
          <img
            style="transform: rotate(180deg)"
            src="./assets/flecha.svg"
            alt="anterior"
          />
          <span class="letter-arrow">anterior</span>
        </a>
      </li>

      @for (i of getPaginationArray(); track i) {
      <li class="page-item" [class.active]="currentPage === i">
        <a class="page-link" (click)="onPageChange(i)">{{ i }}</a>
      </li>
      } @if (totalPages > 3) { @if (currentPage > 3) {
      <li class="page-item">
        <span class="page-link">...</span>
      </li>
      } @if (currentPage > 3) {
      <li class="page-item active">
        <a class="page-link">{{ currentPage }}</a>
      </li>
      } @if (currentPage) {
      <li class="page-item">
        <span class="page-link">...</span>
      </li>
      }

      <div class="input-number-container">
        <input
          type="number"
          [(ngModel)]="inputPage"
          min="1"
          [max]="totalPages"
        />
        <button (click)="goToPage(inputPage)">Ir</button>
      </div>

      }

      <li class="page-item" style="margin-left: 1rem">
        <a
          class="page-link"
          [class.disabled]="currentPage === totalPages"
          (click)="onPageChange(currentPage + 1)"
        >
          <span class="letter-arrow">siguiente</span>
          <img src="./assets/flecha.svg" alt="siguiente" />
        </a>
      </li>
    </ul>
  </nav>

  @if (config.showTotals) {
  <div class="totals">
    <div class="totals-item">
      <span>Total Páginas: </span>
      <p>{{ totalPages }}</p>
    </div>
    <div class="totals-item">
      <span>Total Registros: </span>
      <p>{{ totalRegistros }}</p>
    </div>
    @for (field of config.totalFields; track $index) {
    <div class="totals-prima">
      <span>Total {{ getColumnLabel(field) }}: </span>
      <p>{{ formatTotal(field) }}</p>
    </div>
    }
  </div>
  }
</div>
}
